import type { ComponentPropsWithoutRef } from 'react';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { cn } from '@/utils/tailwind.util';
import { DEFAULT_AVATAR_IMAGE } from '../consts/avatar.constants';
import { AvatarFrame } from './AvatarFrame';
import { UserAvatar } from './UserAvatar';

/**
 * 96px 는 ZUS size variant 에 없는 값이라 임의 클래스로 지정한다.
 * ZUS 에 해당 variant 가 생기면 `size` prop 으로 옮긴다.
 */
const PROFILE_SIZE = 'size-[96px]';
interface ProfileAvatarProps extends ComponentPropsWithoutRef<'div'> {
  avatarData?: AvatarData | null;
}

/** 96px sprite-only avatar for profile pages. Wraps UserAvatar. */
export const ProfileAvatar = ({
  avatarData,
  className,
  ...props
}: ProfileAvatarProps) => {
  if (!avatarData) {
    return <AvatarFrame className={cn(PROFILE_SIZE, className)} {...props}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </AvatarFrame>;
  }
  return <UserAvatar avatarData={avatarData} useSprite spritePixelSize={96} className={className} {...props} data-sentry-element="UserAvatar" data-sentry-component="ProfileAvatar" data-sentry-source-file="ProfileAvatar.tsx" />;
};